var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26521 1.23509C0 2.47017 0 4.45254 0 8.42764V9.13341C0 13.1085 0 15.1013 1.26521 16.3363C2.53042 17.5714 4.56113 17.5714 8.64383 17.5714H9.35617C13.4282 17.5714 15.4696 17.5714 16.7348 16.3363C18 15.1013 18 13.1085 18 9.13341V8.42764C18 4.45254 18 2.47017 16.7348 1.23509C15.4696 0 13.4282 0 9.35617 0H8.63319C4.56113 0 2.53042 0 1.26521 1.23509ZM3.03012 5.34512C3.13644 9.91182 5.47549 12.6518 9.57944 12.6518H9.81335V10.0467C11.3125 10.1921 12.4607 11.2611 12.9179 12.6518H15.0443C14.4595 10.5761 12.9179 9.42402 11.961 8.9881C12.9179 8.4484 14.2682 7.13028 14.5978 5.34512H12.6627C12.2374 6.78778 10.9935 8.1059 9.81335 8.23044V5.34512H7.87832V10.41C6.6769 10.1194 5.15653 8.69749 5.09273 5.34512H3.03012Z",
    fill: "#0077FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.a64cec60.svg";
export { ForwardRef as ReactComponent };